import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticating: true,
    authenticated: false,
    userId: null,
    user: null,
    error: null,
  },
  reducers: {
    signIn(state, action) {
      state.isAuthenticating = false;
      state.authenticated = true;
      state.userId = action.payload.userId;
      state.user = action.payload;
      state.error = null;
    },
    updateUser(state, action) {
      state.user = { ...state.user, ...action.payload };
    },
    signOut(state) {
      state.isAuthenticating = false;
      state.authenticated = false;
      state.userId = null;
      state.user = null;
      state.error = null;
    },
  },
});

export const { signIn, updateUser, signOut } = authSlice.actions;
export default authSlice.reducer;
